var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPetInsurance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Pet-Insurance-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Pet Insurance 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 0.25c-4.38333 0 -7.54846 1.21975 -9.073 1.82866 -0.85506 0.29295 -1.22705 1.13019 -1.22705 1.86774v7.5916c0 1.9178 0.41503 4.2124 1.76277 6.382 1.35015 2.1736 3.61439 4.186 7.25028 5.5691 0.8204 0.348 1.7547 0.3479 2.575 -0.0005 3.5862 -1.3835 5.8488 -3.3956 7.2105 -5.5667 1.3595 -2.1675 1.8014 -4.4616 1.8014 -6.3839V3.9464c0 -0.7966 -0.4141 -1.46494 -1.1765 -1.84572C19.6561 1.36785 16.3798 0.25 12 0.25Zm0 3.8999c-1.1046 0 -2 0.89543 -2 2s0.8954 2 2 2 2 -0.89543 2 -2 -0.8954 -2 -2 -2ZM6.6001 7.25c-1.10457 0 -2 0.89543 -2 2 0 1.1046 0.89543 2 2 2s2 -0.8954 2 -2c0 -1.10457 -0.89543 -2 -2 -2Zm10.8999 0c-1.1046 0 -2 0.89543 -2 2 0 1.1046 0.8954 2 2 2s2 -0.8954 2 -2c0 -1.10457 -0.8954 -2 -2 -2Zm-6.4993 3.3991c0.5 -0.66559 1.4987 -0.66559 1.9987 0l0.0007 0.0008 3.0951 4.0936c0.6886 0.87 -0.0346 2.0065 -0.9951 2.0065H8.90006c-0.96051 0 -1.68378 -1.1365 -0.99514 -2.0065l3.09518 -4.0936 0.0006 -0.0008Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPetInsurance);
export default ForwardRef;